const styles = theme => {
  return ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginBottom: 16,
    boxShadow:'none',
    marginTop: 32,
  }),
  button: {
    marginTop: 30,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: '#fd5622',
    }
  },
  error: {
    background: theme.palette.secondary.main,
    color: theme.palette.common.white,
    textAlign: 'center'
    },
    logo: {
      width: 'auto',
      height: '50px',
      maxHeight: '50px',
      backgroundColor: 'grey',
      border: '1px solid white',
      display: 'inline-block',
      maxWidth: '300px'
    },
    LogoMissing: {
      width: '80px',
      height: '50px',
      maxHeight: '50px',
      maxWidth: '80px',
      backgroundColor: 'grey',
      border: '1px solid white',
      display: 'inline-block'
    },
    logoButton: {
      width: '20px',
      height: '20px',
      minHeight: '20px',
      position: 'relative',
      top: '-40px',
      left: '-10px'
    },
    logoButtonAdd: {
      backgroundColor: theme.palette.success
    },
    logoButtonRemove: {
      backgroundColor: theme.palette.secondary.dark
    },
    logoButtonIcon: {
      fontSize: '8pt'
    },
    logoName: {
      fontSize: '21px',
      fontWeight: '500'
    }
  })
}

export default styles
